
import React, { useEffect, useState, useContext } from "react";
import { getAutoCountries } from '../../Services/API';
import { RaiseVisaEnquiry } from '../../Services/EnquiryApi';
import { AuthContext } from "../../Routes/AuthProvider"
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";

const VisaSearch = () => {
  const { name, userName, corporateId } = useContext(AuthContext);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryName, setSelectedCountryName] = useState("");
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [enquiryMessage, setEnquiryMessage] = useState("");
  const [enquiryStatus, setEnquiryStatus] = useState(false);
  const [visaParams, setVisaParams] = useState({
    departureDate: "",
    noofEntries: "Multiple",
    visaType: "Tourist Visa",
  });

  useEffect(() => {
    const fetchCountries = async () => {
      const data = await getAutoCountries();
      //console.log("Fetched countries:", data);

      const countryList = Array.isArray(data?.countries) ? data.countries : [];
      setCountries(countryList);

      const usa = countryList.find(
        (c) => c.countryCode?.toLowerCase() === "us"
      );
      if (usa) setSelectedCountry(usa.countryCode);
    };

    fetchCountries();
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setVisaParams((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay", // ⬅️ attach popup inside the same div
      minDate: 0,            // ✅ block past dates
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        // Adjust position: place directly below the input div
        setTimeout(() => {
          const offset = $("#dateDisplay").offset();
          const height = $("#dateDisplay").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function (startDate) {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });

        $("#dayNum").text(day);
        $("#monthYear").text(`${month}-${year}`);
        $("#dayName").text(dayName);

        setVisaParams(prev => ({
          ...prev,
          departureDate: startDate
        }));
      },
    });
  }, []);

  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);


  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    setSelectedCountry(countryCode);
    const country = countries.find(
      (c) => c.countryCode === countryCode
    );
    setSelectedCountryName(country?.countryName || "");
  };

  // Calculate total travellers
  const totalTravellers = adults + children + infants;

  // When "Done" clicked → close dropdown
  const handleDone = (e) => {
    e.preventDefault();
    setShowDropdown(false);
  };
  const [travelTypeMode, setTravelTypeMode] = useState("1");
  const handleRaiseRequest = async () => {
    let newErrors = {};

    if (!selectedCountry.trim()) {
      newErrors.country = "Please select a Travelling To Country";
    }

    if (!visaParams.departureDate.trim()) {
      newErrors.date = "Please select a departure Date";
    }
    //else {
    // const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
    // if (!datePattern.test(visaParams.fromDate)) {
    //   newErrors.date = "Date must be in dd/mm/yyyy format";
    // }
    //}
    if (!visaParams.noofEntries.trim()) {
      newErrors.noofEntries = "Please select no of Entries";
    }

    if (!visaParams.visaType.trim()) {
      newErrors.visa = "Please select visa type";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
    //const userId = localStorage.getItem("selectedUserId");
    const userId = emulateCorporateCode || corporateId;
    const CorporateName = localStorage.getItem("selectedCorporateName");
    const requestBody = {
      TravelType: travelTypeMode,
      TravellingCountry: selectedCountry,
      TravellingCountryName: selectedCountryName,
      DepartureDate: visaParams.departureDate,
      NoofEntries: visaParams.noofEntries,
      VisaType: visaParams.visaType,
      Travellers: adults + children + infants,
      NoOfAdult: adults,
      NoOfChild: children,
      NoOfInfant: infants,
      CompanyId: userId,
      OrganizationName: CorporateName,
      CreatedBy: userName
    };

    //console.log("requestBody", requestBody)
    try {
      const result = await RaiseVisaEnquiry(requestBody);
      if (result.success) {
        setEnquiryMessage(result.message)
        setEnquiryStatus(true);
      }
      else {
        setEnquiryMessage(result.message)
      }
      setShowPopup(true);
    } catch {
      alert("Failed to submit enquiry");
    }
  };

  return (
    <>
      <div className='visa_serch'>
        <div className='row'>
          <div className='col-md-6 col-lg-6'>
            <div className='d-flex'>
              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="1"
                    checked={travelTypeMode === "1"}
                    onChange={(e) => {
                      setTravelTypeMode(e.target.value)
                    }}
                  />
                  <label className="form-check-label">Business Travel</label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="2"
                    checked={travelTypeMode === "2"}
                    onChange={(e) => {
                      setTravelTypeMode(e.target.value)
                    }}
                  />
                  <label className="form-check-label">Personal Travel</label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="3"
                    checked={travelTypeMode === "3"}
                    onChange={(e) => {
                      setTravelTypeMode(e.target.value)
                    }}
                  />
                  <label className="form-check-label">Guest Travel</label>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-lg-6'>
            <div className='theme_tx'>
              {/* <h3>Authorized Immigration Checkposts !</h3> */}
            </div>
          </div>
        </div>

        <div className='form_ful'>

          <div className='visa_clo_1'>
            <div className="visa_icon_img">
              <img className="bus_ic" src="/assets/images/visa-blue.png" alt="bus" />
            </div>
            <div className="bus_icon">
              <p>Travelling To</p>

              <select
                className="selct_control"
                value={selectedCountry}
                onChange={handleCountryChange}
              >
                <option value="">Country</option>
                {countries.map((country, index) => (
                  <option key={index} value={country.countryCode}>
                    {country.countryName}
                  </option>
                ))}
              </select>
              {errors.country && <p className="error_mes">{errors.country}</p>}
            </div>
          </div>
          <div className="visa_clo_1">
            <div className="visa_icon_img">
              <img className="bus_ic" src="/assets/images/visa-blue.png" alt="bus" />
            </div>
            <div className="bus_icon">
              <p>Departure</p>


              <div className="travl_from_visa" id="dateDisplay" onClick={() => $("#departureDate").datepicker("show")}>
                <span id="dayNum" style={{ fontSize: "25px", fontWeight: "bold" }}>
                  DD
                </span>{" "}
                <span id="monthYear" style={{ fontSize: "13px" }}>
                  MM-YYYY
                </span>
                <br />
                <span id="dayName">
                  DAY
                </span>
                <input type="text" id="departureDate" style={{ position: "absolute", left: "-9999px" }} />
              </div>
              {errors.date && <p className="error_mes">{errors.date}</p>}
            </div>
          </div>

          <div className='visa_clo_1'>
            <div className="visa_icon_img">
              <img className="bus_ic" src="/assets/images/visa-blue.png" alt="bus" />
            </div>
            <div className="bus_icon">
              <p>No of Entries</p>

              <select className='selct_control'
                name="noofEntries"
                value={visaParams.noofEntries}
                onChange={handleChange}
              >
                <option>Multiple</option>
                <option>Single</option>
              </select>
              {errors.noofEntries && <p className="error_mes">{errors.noofEntries}</p>}
            </div>
          </div>
          <div className='visa_clo_1'>
            <div className="visa_icon_img">
              <img className="bus_ic" src="/assets/images/visa-blue.png" alt="bus" />
            </div>
            <div className="bus_icon">
              <p>Type of Visa</p>

              <select className='selct_control'
                name="visaType"
                value={visaParams.visaType}
                onChange={handleChange}>
                <option>Tourist Visa</option>
                <option>Visit Visa</option>
                <option>Student Visa</option>
                <option>Business Visa</option>
              </select>
              {errors.visa && <p className="error_mes">{errors.visa}</p>}
            </div>
          </div>
          <div className="visa_clo_1 Travellers" style={{ position: "relative" }}>
            <div className="visa_icon_img">
              <img className="bus_ic" src="/assets/images/visa-blue.png" alt="bus" />
            </div>
            <div className="bus_icon">
              <p>Travellers</p>

              <div className="p-0">


                {/* display summary */}
                <div
                  className="travl_from_visa"
                  onClick={() => setShowDropdown(!showDropdown)}
                  style={{ cursor: "pointer" }}
                >
                  {totalTravellers} Traveller{totalTravellers > 1 ? "s" : ""}{" "}
                  <img
                    src="/assets/images/down.png"
                    className="down"
                    alt="flight"
                    style={{ width: "14px", marginLeft: "6px" }}
                  />
                </div>

                <p>
                  {adults} Adult{adults > 1 ? "s" : ""}
                  {children > 0 && `, ${children} Child${children > 1 ? "ren" : ""}`}
                  {infants > 0 && `, ${infants} Infant${infants > 1 ? "s" : ""}`}
                </p>
              </div>


              {showDropdown && (
                <div
                  className="insurance dropdown_passenger_in"
                  id="toggle_showSelectVisa"

                >
                  <div className="traveller-calulate-persons">
                    <div className="passengers">
                      <div className="passengers-types">
                        {/* Adults */}
                        <div className="passengers-type">
                          <div className="text">
                            <div className="type-label">
                              <p>Adult</p>
                              <span>12+ yrs</span>
                            </div>
                          </div>
                          <div className="button-set">
                            <select
                              className="form-select form-select-solid"
                              value={adults}
                              onChange={(e) => setAdults(parseInt(e.target.value))}
                            >
                              {[...Array(10).keys()].map((n) => (
                                <option key={n} value={n}>
                                  {n}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {/* Children */}
                        <div className="passengers-type">
                          <div className="text">
                            <div className="type-label">
                              <p>Children</p>
                              <span>2 - less than 12 yrs</span>
                            </div>
                          </div>
                          <div className="button-set">
                            <select
                              className="form-select form-select-solid"
                              value={children}
                              onChange={(e) => setChildren(parseInt(e.target.value))}
                            >
                              {[...Array(10).keys()].map((n) => (
                                <option key={n} value={n}>
                                  {n}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {/* Infants */}
                        <div className="passengers-type">
                          <div className="text">
                            <div className="type-label">
                              <p>Infant</p>
                              <span>0 - 2 yrs</span>
                            </div>
                          </div>
                          <div className="button-set">
                            <select
                              className="form-select form-select-solid"
                              value={infants}
                              onChange={(e) => setInfants(parseInt(e.target.value))}
                            >
                              {[...Array(10).keys()].map((n) => (
                                <option key={n} value={n}>
                                  {n}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Done button */}
                    <div className="col-md-12 d-flex">
                      <button className="done_selct" onClick={handleDone} >Done </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='Rooms_Guests_Serch'>
            <button className="Serch" onClick={handleRaiseRequest} type="button">
              Raise Request
            </button>
          </div>

        </div>

        {/* <div className='row text-end'>
        <div className='visa_anul'>
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="check1" name="option1" value="something" />
            <label class="form-check-label" for="check1">I have read and agree to the <a href="/" target="_blank">Rules and Regulations</a> for booking e-visa for customers. </label>
          </div>
         
          <div className='gp_btn'>
            <label>Application Type</label>
            <select className='VisaApplication'>
              <option>Urgent</option>
              <option>Normal</option>
              <option>Non-Urgent</option>
            </select>
          </div>
           
        </div>

      </div> */}


      </div>

      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h3>{enquiryMessage}</h3>
            <button
              onClick={() => {
                setShowPopup(false);
                window.location.reload();
              }}
              className="btn btn-primary"
            >
              Ok
            </button>
          </div>
        </div>
      )}
    </>

  );
};

export default VisaSearch;
